import { alpha, keyframes } from '@mui/material';

const pulseLight = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(1.5);
  }
  100% {
    opacity: 1;
    transform: scale(2);
  }
`;

const endPulseLight = keyframes`
  0% {
    opacity: 1;
    transform: scale(2);
  }
  100% {
    opacity: 1;
    transform: scale(0.95);
  }
`;

const getGradientPosition = (pos) => {
  switch (pos) {
    case 'TOP_LEFT':
      return { top: 0, left: 0, borderRadius: '0 0 33.18% 0' };
    case 'TOP_RIGHT':
      return { top: 0, right: 0, borderRadius: '0 0 0 33.18%' };
    case 'BOTTOM_LEFT':
      return { bottom: 0, left: 0, borderRadius: '0 33.18% 0 0' };
    case 'BOTTOM_RIGHT':
    default:
      return { bottom: 0, right: 0, borderRadius: '33.18% 0 0 0' };
  }
};

export const gradientBoxStyles = (position = 'BOTTOM_RIGHT') => {
  const positionStyles = getGradientPosition(position);

  return {
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    background:
      'linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0))',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    position: 'relative',
    padding: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      padding: '1px',
      background:
        'linear-gradient(180deg, rgba(16, 152, 247, 0.2) 0%, rgba(255, 110, 114, 0.2) 50%, rgba(246, 174, 45, 0.2) 100%)',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      ...positionStyles,
      width: '33.18%',
      height: '27.56%',
      background: `radial-gradient(circle at ${
        position === 'TOP_LEFT' || position === 'BOTTOM_LEFT' ? 'left' : 'right'
      } ${
        position === 'TOP_LEFT' || position === 'TOP_RIGHT' ? 'top' : 'bottom'
      }, ${alpha('#5bc0de', 0.1)} 0%, ${alpha('#5bc0de', 0)} 60%)`,
      filter: 'blur(10px)',
      transformOrigin: `${
        position === 'TOP_LEFT' || position === 'BOTTOM_LEFT' ? 'left' : 'right'
      } ${
        position === 'TOP_LEFT' || position === 'TOP_RIGHT' ? 'top' : 'bottom'
      }`,
      opacity: 1,
      transform: 'scale(0.95)',
    },
  };
};

export const gradientBoxStyleWithHoverAnimation = (
  position = 'BOTTOM_RIGHT',
) => {
  const positionStyles = getGradientPosition(position);

  return {
    ...gradientBoxStyles(position),
    '&:hover::before': {
      opacity: 1,
      animation: 'rotateGradient 2.5s infinite',
      background:
        'linear-gradient(88.69deg, #1098F7 0%, #FF6E72 55.44%, #F6AE2D 100.39%)',
    },
    '&:hover::after': {
      ...positionStyles,
      background: `radial-gradient(circle at ${
        position === 'TOP_LEFT' || position === 'BOTTOM_LEFT' ? 'left' : 'right'
      } ${
        position === 'TOP_LEFT' || position === 'TOP_RIGHT' ? 'top' : 'bottom'
      }, ${alpha('#5bc0de', 0.25)} 0%, ${alpha('#5bc0de', 0)} 60%)`,
      animation: `${pulseLight} 1s ease-in-out forwards`,
    },
    '&:not(:hover)::after': {
      ...positionStyles,
      background: `radial-gradient(circle at ${
        position === 'TOP_LEFT' || position === 'BOTTOM_LEFT' ? 'left' : 'right'
      } ${
        position === 'TOP_LEFT' || position === 'TOP_RIGHT' ? 'top' : 'bottom'
      }, ${alpha('#5bc0de', 0.25)} 0%, ${alpha('#5bc0de', 0)} 60%)`,
      animation: `${endPulseLight} 1s ease-in-out forwards`,
    },
    '@keyframes rotateGradient': {
      '0%': { transform: 'rotate(0deg)' },
      '50%': { transform: 'rotate(1deg)' },
      '100%': { transform: 'rotate(0deg)' },
    },
  };
};
